
interface IProps {
    pagination: any,
    setPagination: (obj: any) => void,
    loading: boolean,
}


export const Pagination = ({ pagination, setPagination, loading }: IProps) => {

    const handelChange = (type: any) => {
        let data = { ...pagination }
        if (type == 'next' && pagination.total > pagination.current) {
            data.current++;
        }
        if (type == 'prev' && pagination.current > 1) {
            data.current--;
        }
        setPagination(data)
    }


    return (
        <>
            {loading == false &&
                <div className='w-full h-[40px] mt-4  flex items-center justify-center'>
                    {pagination.total > pagination.current &&
                        <div onClick={() => handelChange('next')} className='w-[140px] h-[35px] mx-2 shadow rounded-md bg-gray-50 flex items-center justify-center text-xs cursor-pointer'>
                            {pagination.current == 1 ? 'نمایش بیشتر' : 'بعدی'}
                        </div>
                    }
                    {pagination.current > 1 &&
                        <div onClick={() => handelChange('prev')} className='w-[140px] h-[35px] mx-2 shadow rounded-md bg-gray-50 flex items-center justify-center text-xs  cursor-pointer'>
                            قبلی
                        </div>
                    }
                </div>

            }
        </>
    );
}